import {useDispatch} from 'react-redux';
import {useIntl} from 'react-intl';


import cartService from '../../../../services/CartService';

import {cartActions} from '../index';
import {notificationConstants} from '../../Notification';
import {useToastMessage} from '../../Notification';


/**
 * @returns {(function({cartId: *, cartItems: *}): Promise<void>)|*}
 */
function useAddCartItems() {

    const dispatch = useDispatch();
    const {formatMessage} = useIntl();
    const toastMessage = useToastMessage();

    /**
     * @param cartId {string} Cart id to remove items from
     * @param cartItems {object[]} Array of cart items to be removed
     */
    return async (cartId, cartItems) => {

        if (cartItems.length === 0) {

            throw Error('No cart items provided to add');
        }

        const addCartItemsResponse = await cartService.addCartItems(cartId, cartItems);
        dispatch(cartActions.onCartLoaded(addCartItemsResponse.cart));

        const {addedItemCount, failedItemCount} = addCartItemsResponse;
        if (addedItemCount > 0) {
            toastMessage(
                notificationConstants.NOTIFICATION_TYPE_SUCCESS,
                formatMessage({id: 'notification.cart.add.success'}, {addedItemCount})
            );
        }
        if (failedItemCount > 0) {
            toastMessage(
                notificationConstants.NOTIFICATION_TYPE_ERROR,
                formatMessage({id: 'notification.cart.add.error'}, {failedItemCount})
            );
        }
    };
}


export default useAddCartItems;
